export const RouteName = {
    CycleEvaluation: '/performance-management/cycle-evaluation',
    CycleEvaluationForm: '/performance-management/cycle-evaluation/create',
    CycleEvaluationDefineAudience:
        '/performance-management/cycle-evaluation/create/define-audience',
    CycleEvaluationSelectEvaluators:
        '/performance-management/cycle-evaluation/create/select-evaluators',
    CycleEvaluationSelectTemplate:
        '/performance-management/cycle-evaluation/create/select-template',
    CycleEvaluationQuestionnaire: '/performance-management/cycle-evaluation/create/questionnaire',
    CycleEvaluationScheduleCreation: '/performance-management/cycle-evaluation/create/schedule',
    CycleEvaluationSuccessMessage: '/performance-management/cycle-evaluation/success',
    CycleEvaluationGroupForm: '/performance-management/cycle-evaluation/configure',
    CycleEvaluationGroupLaunchSummary: '/performance-management/cycle-evaluation/launch-summary',
    Evaluation360: '/performance-management/360-evaluation/dashboard',
    Eval360Form: '/performance-management/360-evaluation/create',
    Eval360AssignReviewer: '/performance-management/360-evaluation/create/assign-reviewer',
    Eval360QuestionnaireCreation: '/performance-management/360-evaluation/create/questionnaire',
    Eval360ScheduleCreation: '/performance-management/360-evaluation/create/schedule',
    Eval360SelectReviewee: '/performance-management/360-evaluation/create/select-reviewee',
    Eval360SelectTemplate: '/performance-management/360-evaluation/create/select-template',
    Eval360Results: '/performance-management/360-evaluation/results',
    SelfAssessmentForm: '/performance-management/self-assessment/create',
    SuccessMessage: '/performance-management/success',
    SurveyAnswer: '/performance-management/survey-answer',
    CommentThread: '/performance-management/comment-thread',
    Competencies: '/performance-management/competencies',
    CompetencyProfileCreate: '/performance-management/competency-profiles/new',
    ManageTemplates: '/performance-management/manage-templates',
    TemplateQuestionnaire: '/performance-management/manage-templates/questionnaire',
    TemplateTranslation: '/performance-management/manage-templates/translate',
    MeetingPlanTemplate: '/performance-management/manage-templates/meeting-plan',
    Eval360QuestionnaireTranslation:
        '/performance-management/360-evaluation/translate-questionnaire',
    CycleEvaluationQuestionnaireTranslation:
        '/performance-management/cycle-evaluation/translate-questionnaire',
    SelfAssessmentQuestionnaireTranslation:
        '/performance-management/self-assessment/translate-questionnaire',
    VisionValues: '/performance-management/vision-values',
    ManagerAssessment: '/performance-management/manager-assessment',
    ManagerAssessmentEvaluation: '/performance-management/manager-assessment/evaluation',
    ManagerAssessmentResults: '/performance-management/manager-assessment/results',
    ManagerAssessmentPrepareMeeting: '/performance-management/manager-assessment/prepare-meeting',
    ManagerAssessmentMeet: '/performance-management/manager-assessment/meet-employee',
    PerformanceProfile: '/performance-management/performance-profile/:id',
    // Employee-centric competency-profiles admin page. Lives under /administration/* so the
    // URL matches production; the host forwards /administration/profils-competences to this MFE.
    // `develop` moved it under /performance-management/, which the host does not route.
    CompetencyProfilesAdmin: '/administration/profils-competences',
    CreateCompetencyProfile: '/performance-management/competency-profiles/create',
    PeriodResults: '/performance-management/period-results',
    Objectives: '/performance-management/objectives',
    ObjectivesNew: '/performance-management/objectives/new',
    ObjectivesNewType: '/performance-management/objectives/new/:type',
    ObjectivesWithoutObjective: '/performance-management/objectives/employees-without-objectives',
    ObjectivePillar: '/performance-management/objectives/pillar/:pillarId',
    ObjectiveEdit: '/performance-management/objectives/:id/edit',
    ObjectiveDetail: '/performance-management/objectives/:id',
    ThematicMeetings: '/performance-management/rencontres-employes',
    EmployeePortal: '/performance-management/employee-portal',
    CompetencyMatrixReport: '/performance-management/rapports/competences',
    CompensationReport: '/performance-management/rapports/remuneration',
    CalibrationReport: '/performance-management/rapports/calibration',
} as const;

export type RouteNameType = (typeof RouteName)[keyof typeof RouteName];
